module.exports = "<dcs-page-ribbon></dcs-page-ribbon>\n<div>\n    <router-outlet name=\"navbar\"></router-outlet>\n</div>\n<div class=\"container-fluid\">\n    <div class=\"card jh-card\">\n        <router-outlet></router-outlet>\n        <router-outlet name=\"popup\"></router-outlet>\n    </div>\n    <dcs-footer></dcs-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/main/main.component.html
// module id = 316
// module chunks = 0